export const options = [
  { label: '5 days', value: 5 },
  { label: '10 days', value: 10 },
  { label: '15 days', value: 15 },
];
